module.exports = __webpack_public_path__ + "img/gift_list.b65c5163.svg";